import React, { useCallback, useState } from 'react'
import { Action, PanelMessageIn, PanelMessageOut } from './types'

import {
  getHost, sendMessageDotNet
} from './utilities'

interface SendGeometryOptions {
  layer: string
  units: string
}

interface SendGeometry {
  uniqueId: string,
  options?: SendGeometryOptions
}

export const useSendMessage = () => {
  const host = getHost()
  const [state, setState] = useState<PanelMessageOut | undefined>()

  const sendMessage = useCallback((action: Action, message: PanelMessageIn) => {

    const response = sendMessageDotNet({ action, ...message })

    setState((state) => ({
      ...state,
      response,
    }))

    return response
  }, [])

  return ({
    host,
    state,
    sendMessage,
  })
}
